export enum FlexAssessmentContextAction {
  showNotification = 'showNotification',
  dismissNotification = 'dismissNotification',
  setFieldValue = 'setFieldValue',
  setQuestions = 'setQuestions',
  selectAnswer = 'selectAnswer',
  setAccessCodeConfig = 'setAccessCodeConfig',
  setOrgConfig = 'setOrgConfig',
  setAssessmentId = 'setAssessmentId',
  setUserAuthenticationObject = 'setUserAuthenticationObject',
  saveAllUserInput = 'saveAllUserInput',
  setAccessCode = 'setAccessCode',
  setInAppAssessmentConfig = 'setInAppAssessmentConfig',
  setAlias = 'setAlias',
  setInB2BCampaignAssessment = 'setInB2BCampaignAssessment',
  setAssessmentResult = 'setAssessmentResult',
  setSubCategoryMaxScores = 'setSubCategoryMaxScores',
  setEntrancePath = 'setEntrancePath',
}
